<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div style="float: right" class="wsmobileheader">

     <!-- <a id="wsnavtoggle" class="animated-arrow"><span></span></a>-->

  <button (click)="toggleMenu()" class="hamburger">
  <span>toggle menu</span>
   </button>
  

  </div>

<router-outlet></router-outlet>
<div [@visibilityChanged] *ngIf="menuState==='in'" >
  <button style="    height: 35px;
    width: 35px;
    top: 10px;
    position: fixed;
    z-index: 10000;
    right: 20px;
    border-radius: 20px;
    padding-top: 5px;" (click)="toggleMenu()" ><i class="material-icons">
      close
      </i></button>
    <app-appmobilesidemenu  ></app-appmobilesidemenu>
</div>
